import { z } from 'zod';

export const accountSchema = z.object({
    id: z.number().default(-1),
    email: z.string().email().default('xxx@xxx.de'),
    username: z.string().default(''),
    first_name: z.string().default(''),
    last_name: z.string().default(''),

    customGroups: z.array(z.number()).default([]),

    // Zusatzfelder
    strasse: z.string().nullable().optional().default(''),
    hausnummer: z.string().nullable().optional().default(''),
    plz: z.string().nullable().optional().default(''),
    stadt: z.string().nullable().optional().default(''),
    land: z.string().nullable().optional().default(''),
    geburtstag: z.string().nullable().optional().default(null),
    telefon: z.string().nullable().optional().default(''),
    mobil: z.string().nullable().optional().default(''),
    beruf: z.string().nullable().optional().default(''),

    // Fremdschlüssel
    leibfux_von: z.number().nullable().optional().default(null),
    leibbursche_von: z.array(z.number()).optional().default([]),

    biernamen: z.string().nullable().optional().default(''),
    aemter: z.string().nullable().optional().default(''),

    // Status als reine ID (statt verschachteltes Objekt)
    status: z.number().nullable().optional().default(null),

    webseite: z.string().nullable().optional().default(''),
    arbeitgeber: z.string().nullable().optional().default(''),
    xing: z.string().nullable().optional().default(''),
    linkedin: z.string().nullable().optional().default(''),
    facebook: z.string().nullable().optional().default(''),
    instagram: z.string().nullable().optional().default(''),
    eintritt: z.string().nullable().optional().default(''),
    verstorben: z.string().nullable().optional().default(''),

    // Kontostatus (vom Serializer nur für Superuser voll befüllt) – für die
    // Sichtbarkeit des "Imitieren"-Buttons genutzt. Backend bleibt maßgeblich.
    is_active: z.boolean().optional().default(true),
    is_superuser: z.boolean().optional().default(false),

    // profile_picture kommt NICHT mehr in der Listen-Antwort (RAM-Schutz); es wird nur
    // noch beim Upload gesetzt (base64). Für die Anzeige nutzen wir avatar_url (lazy per URL).
    profile_picture: z.string().nullable().optional().default(''),
    has_avatar: z.boolean().optional().default(false),
    avatar_url: z.string().nullable().optional().default(null),
});

export type IAccount = z.infer<typeof accountSchema>;
